export default "__VITE_ASSET__BEzkbbor__"